import type { UnitPresets } from "@/libs/units/presets";

export const canadianOilFieldUnits: UnitPresets = {
  "Generic.Power.Hydraulic": "hp",
  "Generic.Power.Real": "kW",
  "Generic.Power.Apparent": "kVA",
  "Generic.Current": "A",
  "Generic.Density": "kg/m³",
  "Generic.FlowRate.Liquid": "m³/d",
  "Generic.FlowRate.Gas": "e³m³/d",
  "Generic.Length.Large": "Meters",
  "Generic.Length.Small": "Centimeters",
  "Generic.Ratio.Liquid": "m3/m3",
  "Generic.Mass": "kg",
  "Generic.Pressure": "kPa",
  "Generic.Speed": "m/s",
  "Generic.Temperature": "C°",
  "Generic.Viscosity": "Centipoise",
  "Generic.Voltage": "V",
  "Generic.Volume": "L",
  "Generic.VolumeRate.PI": "m³/d/kPa",
  "Generic.Concentration": "ppm"
};

/*
{
  "Length.write.Feet": "Meters",
  "PBHP.convert.PSIA": "kPa",
  "SBHP.convert.PSIA": "kPa",
  "Length.convert.Feet": "Meters",
  "Intake HP.convert.hp": "hp",
  "Length.convert.Inches": "Meters",
  "Oil Gravity.write.API": "API",
  "Incoming Power.write.V": "V",
  "Pump Length.write.Feet": "Meters",
  "Shaft Limit.convert.hp": "hp",
  "Gas Rate.write.mscf/d": "e³m³/d",
  "Motor Current.convert.A": "A",
  "Oil Gravity.convert.API": "API",
  "Pump Depth.convert.Feet": "Meters",
  "Surface kVA.convert.kVA": "kVA",
  "Top of Perfs.write.Feet": "Meters",
  "Total Voltage.convert.V": "kV",
  "Datum Point.convert.Feet": "Meters",
  "Required kVA.convert.kVA": "kVA",
  "Average Liquid Density.convert.lb/ft³": "kg/m³",
  "Produced TDH.convert.Feet": "Meters",
  "Required TDH.convert.Feet": "Meters",
  "Startup Voltage.convert.V": "Dead Oil Viscosity.write.CentipoisekV",
  "Surface Voltage.convert.V": "kV",
  "Casing Pressure.write.PSIA": "kPa",
  "Max Amps at Temp.convert.A": "A",
  "Operating Temp.convert.F°": "C°",
  "Flow by Motor.convert.ft/s": "m/s",
  "Required Voltage.convert.V": "kV",
  "Test Temperature.write.F°": "C°",
  "Total Volt Loss.convert.VA": "kVA",
  "Tubing Pressure.write.PSIA": "kPa",
  "Datum Point (MD).write.Feet": "Meters",
  "Gas/Oil ratio.write.SCF/STB": "m3/m3",
  "Cable Length .convert.Meters": "Meters",
  "Test Temperature 2.write.F°": "C°",
  "Test Temperature 3.write.F°": "C°",
  "Top Casing Length.write.Feet": "Meters",
  "Top Tubing Length.write.Feet": "Meters",
  "Cable Temperature.convert.F°": "C°",
  "Equipment Length.convert.Feet": "Meters",
  "Fluid Level (MD).convert.Feet": "Meters",
  "Oil Rate.write.STB/D": "m³/d",
  "Surface Temperature.write.F°": "C°",
  "Volt Loss / 1000ft.convert.VA": "kVA",
  "Gas/Liquid ratio.write.SCF/STB": "m3/m3",
  "Bottom Casing Length.write.Feet": "Meters",
  "Bottom Tubing Length.write.Feet": "Meters",
  "Discharge Pressure.convert.PSIA": "kPa",
  "Minimum MLE Length.convert.Feet": "Meters",
  "Oil Rate.convert.STB/D": "m³/d",
  "Shut-in Thrust Load.convert.lbs": "kg",
  "Shut-in Burst Pressure.convert.PSIA": "kPa",
  "Water Rate.write.STB/D": "m³/d",
  "Bubble Point Pressure Override.write.PSIA": "kPa",
  "Gas Rate @ Intake.convert.STB/D": "e³m³/d",
  "Bottom Hole Temperature.write.F°": "C°",
  "Discharge Temperature.convert.F°": "C°",
  "Max Amps at Temperature.convert.A": "A",
  "Pump Intake Pressure.convert.PSIA": "kPa",
  "Water Rate.convert.STB/D": "m³/d",
  "Bubble Point Pressure.convert.PSIA": "kPa",
  "Gas Gravity.write.Specific Gravity": "Specific Gravity",
  "Motor Skin Temperature.convert.F°": "C°",
  "Total Cables Power Loss.convert.kW": "kW",
  "Dead Oil Viscosity.write.Centipoise": "Centipoise",
  "Fluid Above Pump (TVD).convert.Feet": "Meters",
  "Gas Pressure at Intake.convert.PSIA": "kPa",
  "Pump Intake Temperature.convert.F°": "C°",
  "Total Cables Voltage Loss.convert.V": "V",
  "Gas Gravity.convert.Specific Gravity": "Specific Gravity",
  "Water Gravity.write.Specific Gravity": "Specific Gravity",
  "Dead Oil Viscosity 2.write.Centipoise": "Centipoise",
  "Dead Oil Viscosity 3.write.Centipoise": "Centipoise",
  "Shroud Interior Diameter.write.Inches": "Centimeters",
  "Motor Internal Temperature.convert.F°": "C°",
  "Total Liquid Rate.write.STB/D": "m³/d",
  "Water Gravity.convert.Specific Gravity": "Specific Gravity",
  "Average Ambient Temperature.convert.F°": "C°",
  "Gas Rate after Separation.convert.scf/d": "e³m³/d",
  "Target Liquid Rate.write.STB/D": "m³/d",
  "Required Discharge Pressure.convert.PSIA": "kPa",
  "Total Liquid Rate.convert.STB/D": "m³/d",
  "Oil Rate (in situ).convert.STB/D": "m³/d",
  "Target Liquid Rate.convert.STB/D": "m³/d",
  "Well Flowing Pressure (Datum).convert.PSIA": "kPa",
  "Well Flowing Pressure (Perfs).convert.PSIA": "kPa",
  "Static Bottomhole Pressure at Datum [Pr].write.PSIA": "kPa",
  "Total Flowrate Entering Pump.convert.STB/D": "m³/d",
  "Total Flowrate Entering Intake.convert.STB/D": "m³/d",
  "Total Flow Rate Entering Intake.convert.STB/D": "m³/d",
  "Producing Bottomhole Pressure at Datum [Pwf].write.PSIA": "kPa",
  "Liquid Flow Rate Entering Intake.convert.STB/D": "m³/d",
  "Motor Winding Temperature.convert.F°": "C°",
  "Motor Temp Rating.convert.F°": "C°",
  "Produced Discharge Pressure.convert.PSIA": "kPa",
  "Pressure Drop Past Motor.convert.PSIA": "kPa",
  "Bottom of Intake Depth.convert.Feet": "Meters",
  "Water Rate (in situ).convert.STB/D": "m³/d",
  "Productivity Index.convert.stb/d/psi": "m³/d/kPa"
};
*/
